import { render, staticRenderFns } from "./PeauContainer.vue?vue&type=template&id=27473338&"
import script from "./PeauContainer.vue?vue&type=script&lang=js&"
export * from "./PeauContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports